import { useCallback } from 'react';
import { toggleChatwoot, openChatwoot, closeChatwoot } from '../utils/chatwoot';

export const useChatwoot = () => {
  const toggle = useCallback(() => {
    toggleChatwoot();
  }, []);

  const open = useCallback(() => {
    openChatwoot();
  }, []);

  const close = useCallback(() => {
    closeChatwoot();
  }, []);

  return { toggle, open, close };
};
